/************** js for product view-all-ingredients ***************/
jQuery( document ).ready(function() {
  jQuery(".view-all-ingredients-btn").click(function(){
    //console.log('hello2');
      jQuery(".view-full-ingredients-wraper").toggle();
      jQuery(this).toggleClass("active-ingredients");
  });
});
/************** End: js for product view-all-ingredients ***************/

/************** js for product reviews-faqs-tabs ***************/
  jQuery(document).ready(function() {
    jQuery('.custom-tabs-list .tab').on('click', function() {
      var tabId = jQuery(this).data('tab');
      
      jQuery('.custom-tabs-list .tab').removeClass('active');
      jQuery(this).addClass('active');

      jQuery('.tab-content').removeClass('active');
      jQuery('#' + tabId).addClass('active');
    });
  });
/**************End: js for product reviews-faqs-tabs ***************/

/******************** animation js *******************************/
  //  nanoscienceTechnology home animation
  var nanoscienceTechnologyAnim;
  var nanoscienceTechnologyelem = document.getElementById('nanoscienceTechnology')
  var nanoscienceTechnologyanimData = {
      container: nanoscienceTechnologyelem,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      rendererSettings: {
          progressiveLoad: false
      },
      path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/Moleculeshome_revised.json?v=1724307289'
  };
  nanoscienceTechnologyAnim = bodymovin.loadAnimation(nanoscienceTechnologyanimData);

nanoscienceTechnologyAnim.play(); 
//nanoscienceTechnologyAnim.setSpeed(0.5); 


// Mobile  nanoscienceTechnology home animation
  var MobilenanoscienceTechnologyAnim;
  var MobilenanoscienceTechnologyelem = document.getElementById('MobilenanoscienceTechnology')
  var MobilenanoscienceTechnologyanimData = {
      container: MobilenanoscienceTechnologyelem,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      rendererSettings: {
          progressiveLoad: false
      },
      path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/mobilehome_mobile_revised.json?v=1724307289'
  };
  MobilenanoscienceTechnologyAnim = bodymovin.loadAnimation(MobilenanoscienceTechnologyanimData);

MobilenanoscienceTechnologyAnim.play(); 
//MobilenanoscienceTechnologyAnim.setSpeed(0.5); 

  //  nanoplexTechnology home animation
  var nanoplexTechnologyAnim;
  var nanoplexTechnologyelem = document.getElementById('nanoplexTechnology')
  var nanoplexTechnologyanimData = {
      container: nanoplexTechnologyelem,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      rendererSettings: {
          progressiveLoad: false
      },
      path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/skin.json?v=1722321339'
  };
  nanoplexTechnologyAnim = bodymovin.loadAnimation(nanoplexTechnologyanimData);

nanoplexTechnologyAnim.play(); 
//nanoplexTechnologyAnim.setSpeed(0.5); 


// Mobile  BeyondBeautifulSkin home animation
var MobileBeyondBeautifulSkinAnim;
var MobileBeyondBeautifulSkinelem = document.getElementById('MobileBeyondBeautifulSkin')
var MobileBeyondBeautifulSkinanimData = {
    container: MobileBeyondBeautifulSkinelem,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
        progressiveLoad: false
    },
    path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/Content.json?v=1738836177'
};
MobileBeyondBeautifulSkinAnim = bodymovin.loadAnimation(MobileBeyondBeautifulSkinanimData);

MobileBeyondBeautifulSkinAnim.play(); 
//MobileBeyondBeautifulSkinAnim.setSpeed(0.5); 

  //  exploreProducts home animation
  var exploreProductsAnim;
  var exploreProductselem = document.getElementById('exploreProducts')
  var exploreProductsanimData = {
      container: exploreProductselem,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      rendererSettings: {
          progressiveLoad: false
      },
      path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/Bottle_Animation_2.json?v=1732545442'
  };
  exploreProductsAnim = bodymovin.loadAnimation(exploreProductsanimData);

exploreProductsAnim.play(); 
//exploreProductsAnim.setSpeed(0.5); 

//  exploreProducts home animation Updated
var exploreProductsUpdatedAnim;
var exploreProductsUpdatedelem = document.getElementById('exploreProductsUpdated')
var exploreProductsUpdatedanimData = {
    container: exploreProductsUpdatedelem,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
        progressiveLoad: false
    },
    path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/Inskin_Drop_Animation.json?v=1768895613'
};
exploreProductsUpdatedAnim = bodymovin.loadAnimation(exploreProductsUpdatedanimData);

exploreProductsUpdatedAnim.play(); 
//exploreProductsUpdatedAnim.setSpeed(0.5);


// nanoplex tech animation revised
    var homepagerevisednanoplextechAnim;
var homepagerevisednanoplextechelem = document.getElementById('homepagerevisednanoplextech')
var homepagerevisednanoplextechanimData = {
    container: homepagerevisednanoplextechelem,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
        progressiveLoad: false
    },
    path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/Option_2_1.json?v=1754576456'
};
homepagerevisednanoplextechAnim = bodymovin.loadAnimation(homepagerevisednanoplextechanimData);

homepagerevisednanoplextechAnim.play(); 
//homepagerevisednanoplextechAnim.setSpeed(0.5);


 // nanoplex tech animation revised for mobile
    var homepagerevisednanoplextechmobileAnim;
var homepagerevisednanoplextechmobileelem = document.getElementById('homepagerevisednanoplextechmobile')
var homepagerevisednanoplextechmobileanimData = {
    container: homepagerevisednanoplextechmobileelem,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
        progressiveLoad: false
    },
    path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/Option_2_1.json?v=1754576456'
};
homepagerevisednanoplextechmobileAnim = bodymovin.loadAnimation(homepagerevisednanoplextechmobileanimData);

homepagerevisednanoplextechmobileAnim.play(); 
//homepagerevisednanoplextechmobileAnim.setSpeed(0.5);


// beyond beautiful skin animation revised
    var beyondbeautifulskinrevisedAnim;
var beyondbeautifulskinrevisedelem = document.getElementById('beyondbeautifulskinrevised')
var beyondbeautifulskinrevisedanimData = {
    container: beyondbeautifulskinrevisedelem,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
        progressiveLoad: false
    },
    path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/molecules_eb718006-2511-41a1-92ce-5a2ad40f1f6b.json?v=1741077162'
};
beyondbeautifulskinrevisedAnim = bodymovin.loadAnimation(beyondbeautifulskinrevisedanimData);

beyondbeautifulskinrevisedAnim.play(); 
//beyondbeautifulskinrevisedAnim.setSpeed(0.5);


//  ourStoryBanner animation
  var ourStoryBannerAnim;
  var ourStoryBannerelem = document.getElementById('ourStoryBanner')
  var ourStoryBanneranimData = {
      container: ourStoryBannerelem,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      rendererSettings: {
          progressiveLoad: false
      },
      path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/PNR_1.json?v=1723803624'
  };
  ourStoryBannerAnim = bodymovin.loadAnimation(ourStoryBanneranimData);

ourStoryBannerAnim.play(); 
//ourStoryBannerAnim.setSpeed(0.5); 


  //  ourStorymobileBanner animation
  var ourStorymobileBannerAnim;
  var ourStorymobileBannerelem = document.getElementById('ourStorymobileBanner')
  var ourStorymobileBanneranimData = {
      container: ourStorymobileBannerelem,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      rendererSettings: {
          progressiveLoad: false
      },
      path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/Pnr_mobile.json?v=1723804607'
  };
  ourStorymobileBannerAnim = bodymovin.loadAnimation(ourStorymobileBanneranimData);

ourStorymobileBannerAnim.play(); 
//ourStorymobileBannerAnim.setSpeed(0.5); 


//  homeskinsogood home animation
  var homeskinsogoodAnim;
  var homeskinsogoodelem = document.getElementById('homeskinsogoodAnim')
  var homeskinsogoodanimData = {
      container: homeskinsogoodelem,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      rendererSettings: {
          progressiveLoad: false
      },
      path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/Molecules.json?v=1732545343'
  };
  homeskinsogoodAnim = bodymovin.loadAnimation(homeskinsogoodanimData);

homeskinsogoodAnim.play(); 
//homeskinsogoodAnim.setSpeed(0.5); 


//  freeShippingProduct home animation
var freeShippingProductAnim;
var freeShippingProductelem = document.getElementById('freeShippingProduct')
var freeShippingProductanimData = {
    container: freeShippingProductelem,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
        progressiveLoad: false
    },
    path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/content_2.json?v=1738905769'
};
freeShippingProductAnim = bodymovin.loadAnimation(freeShippingProductanimData);

freeShippingProductAnim.play(); 
//freeShippingProductAnim.setSpeed(0.5); 


//  dermatologically home animation
var dermatologicallyAnim;
var dermatologicallyelem = document.getElementById('dermatologicallyAnim')
var dermatologicallyanimData = {
    container: dermatologicallyelem,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
        progressiveLoad: false
    },
    path: 'https://cdn.shopify.com/s/files/1/0735/5829/4839/files/data.json?v=1752852060'
};
dermatologicallyAnim = bodymovin.loadAnimation(dermatologicallyanimData);

dermatologicallyAnim.play(); 
dermatologicallyAnim.setSpeed(0.3); 


/******************** End: animation js *******************************/

document.addEventListener('DOMContentLoaded', function () {
    var thumbsSwiper = new Swiper(".thumbsSwiper", {
        //loop: true,
        spaceBetween: 0,
        //slidesPerView: 7,
        freeMode: true,
        watchSlidesProgress: true,
        /**autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        }, **/
        breakpoints: {
            0: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 12,
            },
        },
    });

    var thumbsSwiper2 = new Swiper(".thumbsSwiper2", {
        //loop: true,
        spaceBetween: 30,
        /**autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },**/
        thumbs: {
            swiper: thumbsSwiper,
        },
    });

    // Stop autoplay on hover for thumbsSwiper2
    document.querySelector('.thumbsSwiper2').addEventListener('mouseenter', function () {
        thumbsSwiper2.autoplay.stop();
    });
    

    // Handle breakpoint changes for both Swipers
    function handleBreakpoint(swiper) {
        swiper.params.autoplay.delay = window.innerWidth < 768 ? 8000 : 2500;
        //swiper.autoplay.start();
    }

    // Trigger on window resize
    window.addEventListener('resize', function() {
        handleBreakpoint(thumbsSwiper);   // Update delay for thumbsSwiper
        handleBreakpoint(thumbsSwiper2);  // Update delay for thumbsSwiper2
    });

    // Initial call to handleBreakpoint to set the correct delay on page load
    handleBreakpoint(thumbsSwiper);
    handleBreakpoint(thumbsSwiper2);


    // Stop autoplay when a thumbsSwiper slide is clicked
    document.querySelectorAll('.thumbsSwiper .swiper-slide').forEach(function(slide) {
        slide.addEventListener('click', function() {
            thumbsSwiper2.autoplay.stop();
        });
    });

});

/********** freeShippingSwiper for product page *****************/
var swiper = new Swiper(".freeShippingSwiper", {
  slidesPerView: 5,
  spaceBetween: 0,
  loop: true,
  speed: 3000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  allowTouchMove: true,
  breakpoints: {
    0: {
      slidesPerView: 1.7,
    },
    500: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 5,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

/********** freeShippingSwiper for product page *****************/
/**var swiper = new Swiper(".productInstructionSwiper", {
  autoplay: {
   enabled: true,
    delay: 0,          
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
    //reverseDirection: true,
  },
  loop:true,
  //centerInsufficientSlides:true,
  speed: 5000,
  breakpoints: {
    300: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 30,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});**/


document.addEventListener('DOMContentLoaded', function () {

  var ingredientSwiper = new Swiper('.ingredientsSwiper', {
    slidesPerView: 5,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    speed: 600,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },

    navigation: {
      nextEl: '.ingred-next-btn',
      prevEl: '.ingred-prev-btn',
    },

    breakpoints: {
      0: { slidesPerView: 2.3 },
      768: { slidesPerView: 3 },
      1199: { slidesPerView: 5 }
    },

    on: {
      imagesReady() {
        setTimeout(() => {
          AOS.refreshHard();
        }, 100);
      }
    }
  });

});


/********** customcollectionSwiper *****************/
var swiper = new Swiper(".customcollectionSwiper", {
  autoplay: {
   // enabled: true,
    delay: 0,          
    //pauseOnMouseEnter: true,
    //disableOnInteraction: false,
    //reverseDirection: true,
  },
  loop:true,
  //centerInsufficientSlides:true,
  speed: 9000,
  breakpoints: {
    0: {
      slidesPerView: 2.5,
      spaceBetween: 29,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1199: {
      slidesPerView: 5,
      spaceBetween: 25,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next.customcollectionSwiper-next-btn",
    prevEl: ".swiper-button-prev.customcollectionSwiper-prev-btn",
  },
});


  /********** customSkinTypeSwiper *****************/
  var swiper = new Swiper(".customSkinTypeSwiper", {
    autoplay: {
      // enabled: true,
      delay: 0,          
      //pauseOnMouseEnter: true,
      //disableOnInteraction: false,
      //reverseDirection: true,
    },
    loop:true,
    //centerInsufficientSlides:true,
    speed: 9000,
    breakpoints: {
      0: {
        slidesPerView: 2.5,
        spaceBetween: 29,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 50,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next.customSkinTypeSwiper-next-btn",
      prevEl: ".swiper-button-prev.customSkinTypeSwiper-prev-btn",
    },
  });





function maxVal(val, itsmax) {
    if (val <= itsmax && val >= 0) return val
    else if (val <0) return 0
    else return itsmax;
}

jQuery( document ).ready(function() {
    jQuery(".img-comp-overlay").each(function () {
        var slider = jQuery(this).parents(".img-comp-container").find(".img-comp-slider");
        var img = jQuery(this).find("img");
    
        var slidef = function () {
            var e = window.event;
            var x = img.offset().left;
            img.parent().width(maxVal(e.pageX - x, jQuery(".img-comp-img").width()));
            slider.css("left", (maxVal(e.pageX - x, jQuery(".img-comp-img").width())) + "px")
        }
    
        //Mouse was pressed
        slider.mousedown(function (e) {
            e.preventDefault();
            jQuery(window).on("mousemove.slideev", this, slidef);
        });
    
        jQuery(window).mouseup(function (e) {
            e.preventDefault();
            jQuery(window).off("mousemove.slideev");
        });
    
        //Finger is swiping
        slider.on("touchmove", function (e) {
            e.preventDefault();
            var t = e.touches[0];
            var x = img.offset().left;
            img.parent().width(maxVal(t.pageX - x, jQuery(".img-comp-img").width()));
            slider.css("left", (maxVal(t.pageX - x, jQuery(".img-comp-img").width())) + "px")
        })
    });
}); 




/**************************************** on product page "GOES WELL WITH" section js ************************************************/
document.addEventListener('DOMContentLoaded', function () {
  const pairWithProducts = document.querySelectorAll('.pair-with-product');

  if (!pairWithProducts.length) return;

  /* =========================================
     VARIANT SELECTION
  ========================================= */

  pairWithProducts.forEach(function (productBox) {
    const variantButtons = productBox.querySelectorAll('.pair-with-variant-button');
    const variantInput = productBox.querySelector('.pair-with-variant-id');
    const priceElement = productBox.querySelector('.pair-with-current-price');
    const comparePriceElement = productBox.querySelector('.pair-with-compare-price');
    const addButton = productBox.querySelector('.pair-with-add-button');
    const addText = productBox.querySelector('.pair-with-add-text');

    variantButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        variantButtons.forEach(function (item) {
          item.classList.remove('pair-with-variant-selected');
        });

        button.classList.add('pair-with-variant-selected');

        const variantId = button.dataset.pairWithVariantId;
        const price = parseInt(button.dataset.pairWithPrice || '0', 10);
        const comparePrice = parseInt(button.dataset.pairWithComparePrice || '0', 10);

        if (variantInput) {
          variantInput.value = variantId;
        }

        if (priceElement) {
          priceElement.textContent = pairWithFormatMoney(price);
        }

        if (comparePriceElement) {
          if (comparePrice > price) {
            comparePriceElement.textContent = pairWithFormatMoney(comparePrice);
            comparePriceElement.hidden = false;
          } else {
            comparePriceElement.hidden = true;
          }
        }

        if (addButton) {
          addButton.disabled = false;
        }

        if (addText) {
          addText.textContent = 'Add to bag';
        }
      });
    });
  });

  /* =========================================
     ADD TO CART
  ========================================= */

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.pair-with-form');

    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('.pair-with-add-button');
    const buttonText = form.querySelector('.pair-with-add-text');
    const loadingText = form.querySelector('.pair-with-add-loading');
    const variantInput = form.querySelector('.pair-with-variant-id');

    if (!variantInput || !variantInput.value) {
      return;
    }

    if (button) {
      button.disabled = true;
    }

    if (buttonText) {
      buttonText.hidden = true;
    }

    if (loadingText) {
      loadingText.hidden = false;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantInput.value),
            quantity: 1
          }
        ]
      })
    })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to add product to cart.');
      }

      return response.json();
    })
    .then(function () {

      /* =========================================
         TELL STILETTO CART TO REFRESH
      ========================================= */

      document.dispatchEvent(
        new CustomEvent('apps:product-added-to-cart')
      );

      document.dispatchEvent(
        new CustomEvent('pair-with:cart-added')
      );

      /* =========================================
         OPEN CART DRAWER
      ========================================= */

      setTimeout(function () {

        /* Try common Stiletto cart drawer elements */
        const cartDrawer =
          document.querySelector('cart-drawer') ||
          document.querySelector('quick-cart') ||
          document.querySelector('[data-cart-drawer]') ||
          document.querySelector('.cart-drawer');

        /* Try custom open method */
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }

        /* Try show method */
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show();
          return;
        }

        /* Try opening button */
        const cartButton =
          document.querySelector('[data-cart-toggle]') ||
          document.querySelector('[data-cart-drawer-toggle]') ||
          document.querySelector('.cart-toggle') ||
          document.querySelector('.header-cart') ||
          document.querySelector('[aria-controls*="cart"]');

        if (cartButton) {
          cartButton.click();
          return;
        }

        /* Try Stiletto event */
        document.dispatchEvent(
          new CustomEvent('cart:open')
        );

      }, 500);

    })
    .catch(function (error) {

      console.error(
        'Pairs Well With Add to Cart:',
        error
      );

      alert(
        'Unable to add this product to cart. Please try again.'
      );

    })
    .finally(function () {

      if (button) {
        button.disabled = false;
      }

      if (buttonText) {
        buttonText.hidden = false;
      }

      if (loadingText) {
        loadingText.hidden = true;
      }

    });

  });

});
/****************************************End: on product page "GOES WELL WITH" section js ************************************************/